import React from "react";
import {
  View,
  Modal,
  StyleSheet,
  Dimensions,
  TouchableWithoutFeedback,
} from "react-native";
import Text from "@components/AppText";

import Button from "@components/Button";
import ImagePicker from "react-native-image-crop-picker";
import { normalize, width, height } from "@utils/metrics";

import t from "@constants/localization";
import testIds from "@constants/testIds";

const PATH = "components/Profile/ImageModal";

const ImageModal = ({
  visible,
  onRequestClose = () => {},
  takePhoto = () => {},
  chooseFromLibrary = () => {},
  removeProfile = () => {},
}) => {
  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      animationType="slide"
      onRequestClose={onRequestClose}
      transparent={true}
      visible={visible}
    >
      <TouchableWithoutFeedback
        testID={testIds.image_Modal}
        onPress={onRequestClose}
      >
        <View style={{ flex: 1, backgroundColor: "rgba(0,0,0,0.2)" }}>
          <View style={styles.modal}>
            <View
              style={{
                backgroundColor: "rgba(0,0,0,0.1)",
                width: 30,
                height: 5,
                alignSelf: "center",
                borderRadius: 20,
              }}
            />
            <View style={styles.heading} testID={testIds.change_profile_photo}>
              <Text bold style={{ fontSize: normalize(22) }}>
                {t(`${PATH}/changeProfilePhoto`)}
              </Text>
            </View>

            <Button
              testID={testIds.take_photo}
              btnText={t(`${PATH}/takePhoto`)}
              buttonFontType="bold"
              fontSize={normalize(18)}
              buttonWidth={width * 0.89}
              // isSubmitting={loading}
              onPress={takePhoto}
              height={normalize(50)}
              borderRadius={10}
              containerStyle={{
                alignSelf: "center",
                //   marginTop: "auto",
                marginBottom: normalize(10),
              }}
            />
            <Button
              testID={testIds.choose_From_Library}
              btnText={t(`${PATH}/chooseFromLibrary`)}
              buttonFontType="bold"
              fontSize={normalize(18)}
              buttonWidth={width * 0.89}
              // isSubmitting={loading}
              onPress={chooseFromLibrary}
              height={normalize(50)}
              borderRadius={10}
              containerStyle={{
                alignSelf: "center",
                //   marginTop: "auto",
                marginBottom: normalize(10),
              }}
            />
            <Button
              testID={testIds.delete_Photo}
              btnText={t(`${PATH}/removeProfilePhoto`)}
              buttonFontType="bold"
              fontSize={normalize(18)}
              buttonWidth={width * 0.89}
              // isSubmitting={loading}
              onPress={removeProfile}
              height={normalize(50)}
              borderRadius={10}
              containerStyle={{
                alignSelf: "center",
                //   marginTop: "auto",
                //   marginBottom: normalize(10),
              }}
            />
          </View>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

export default ImageModal;
const styles = StyleSheet.create({
  modal: {
    marginTop: "auto",
    backgroundColor: "white",
    height: "auto",
    paddingVertical: normalize(18),
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    elevation: 2,
    borderWidth: 2,
    borderBottomWidth: 0,
    borderColor: "rgba(0,0,0,0.1)",
  },
  heading: {
    alignSelf: "center",
    marginVertical: normalize(10),
    marginBottom: normalize(20),
    alignItems: "center",
  },
  title: {
    alignSelf: "center",
  },
  subtitle: {
    alignSelf: "center",
    color: "rgba(0,0,0,0.56)",
  },
  button: {
    width: Dimensions.get("window").width * 0.85,
    alignSelf: "center",
    marginVertical: 10,
    backgroundColor: "#E40046",
    borderColor: "#E40046",
  },
});
